import React from 'react';
import 'antd/dist/antd.css';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Form } from 'antd';
import Quill from "quill";

const Font = Quill.import('formats/font');
// We do not add Aref Ruqaa since it is the default
Font.whitelist = ['Montserrat', 'Serif', 'Monospace','Sans Serif', 'Anton'];
Quill.register(Font, true);

const Component = ({ text = '<h1>Placeholder text.</h1>' }) => {
    return <div dangerouslySetInnerHTML={{ __html: text }} className="ant-typography" />;
};

const EditForm = props => {
    const { getFieldDecorator } = props.form;

    const toolbarOptions = [
        [{ font: Font.whitelist }],
        [{ header: [1, 2, 3, 4, false] }],
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons

        [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
        [{ align: [] }],
        [{ direction: 'rtl' }], // text direction

        [{ color: [] }, { background: [] }], // dropdown with defaults from theme

        ['clean'] // remove formatting button
    ];

    return (
        <Form.Item label="Paragraph content" required>
            {getFieldDecorator('text', { initialValue: props.text })(<ReactQuill modules={{ toolbar: toolbarOptions }} theme="snow" />)}
        </Form.Item>
    );
};
EditForm.defaultProps = {
    text: '<h1>Placeholder text.</h1>'
};

export { Component, EditForm };
